/* =========================================
   STORAGE (24H Expiry)
========================================= */
const setWithExpiry = (key, value, ttl = 24) => {
  localStorage.setItem(
    key,
    JSON.stringify({
      value,
      expiry: Date.now() + ttl * 3600000
    })
  );
};

const getWithExpiry = (key) => {
  const raw = localStorage.getItem(key);
  if (!raw) return null;

  try {
    const item = JSON.parse(raw);
    if (!item || Date.now() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch {
    return null;
  }
};

/* =========================================
   STATE
========================================= */
const modelData = getWithExpiry('voltyid:modelData');

const state = {
  registered: getWithExpiry('voltyid:registered') === 'true',
  currentStep: Number(getWithExpiry('voltyid:step') || 1)
};

const $ = (q, c = document) => c.querySelector(q);
const $$ = (q, c = document) => [...c.querySelectorAll(q)];

/* =========================================
   STEPPER (UNCHANGED STRUCTURE)
========================================= */
const stepLabels = [
  'Register Your Printer',
  'Unbox Your Printer',
  'Connect the Printer',
  'Install Ribbon and Cards',
  'Install Printer Driver',
  'Install and Activate Software',
  'Test Your Printer',
  'Start Designing Cards',
  'Essential Maintenance Tips',
  'Setup Completed 🎉',
];

const totalSteps = stepLabels.length;

const welcomeView = $('#welcomeView');
const stepsView = $('#stepsView');
const stepperEl = $('#stepper');
const stepperWrap = $('#stepperWrap');


// --- Stepper builder ---
function buildStepper() {
  stepperEl.innerHTML = '';
  for (let i = 1; i <= totalSteps; i++) {
    const li = document.createElement('div');
    li.className = 'step';
    li.dataset.step = i;
    li.innerHTML = `<button aria-label="Go to step ${i}"><span class="dot"><p class="f--13px lh--loosev mf--11px f--bold-500 m-0">Step ${i}</p> </span><span class="label"><p class="f--16px lh--loosev f--bold-500 mf--14px ">${stepLabels[i - 1]}</p></span></button>`;
    li.addEventListener('click', () => goToStep(i));
    stepperEl.appendChild(li);
  }
}

// --- View logic ---
function setViewVisibility() {
  const urlParams = new URLSearchParams(window.location.search);
  const stepParam = urlParams.get("step");

  if (stepParam === "welcome" && !state.registered && !state.currentStep) {
    // ✅ Show welcome if explicitly in URL (first visit)
    welcomeView.classList.add("visible");
    welcomeView.classList.remove("hidden");
    stepsView.classList.add("hidden");
    stepsView.classList.remove("visible");
  } else {
    // ✅ Otherwise go straight to steps
    welcomeView.classList.add("hidden");
    welcomeView.classList.remove("visible");
    stepsView.classList.remove("hidden");
    stepsView.classList.add("visible");
    stepperWrap.classList.add("visible");

    // If nothing stored, start at step 1
    if (!state.currentStep || state.currentStep === 0) {
      state.currentStep = 1;
      setWithExpiry("voltyid:step", "1");
    }
  }
}

/* =========================================
   THESE FUNCTIONS REMAIN SAME
========================================= */
function renderStepper() {
  $$('.step', stepperEl).forEach((el) => {
    const i = Number(el.dataset.step);
    el.classList.remove('active', 'complete', 'locked');

    if (i === state.currentStep) {
      el.classList.add('active');
    } else if (i < state.currentStep) {
      el.classList.add('complete');
    }

    // 🔑 Normally lock >1 if not registered
    // but if a model is stored, unlock all
    const hasModel = !!getWithExpiry("voltyid:modelData");
    if (!state.registered && !hasModel && i > 1) {
      el.classList.add('locked');
    }
  });

  if (state.currentStep === 1) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

function showStep(step) {
  $$('.regcard[id^="step-"]').forEach((s) => s.classList.add('hidden'));
  const section = $(`#step-${step}`);
  if (section) {
    section.classList.remove('hidden');
  }
}

function goToStep(step) {
  if (!state.registered && step > 1) return;

  state.currentStep = step;
  setWithExpiry('voltyid:step', String(step));

  renderStepper();
  showStep(step);
  window.scrollTo({ top: 0, behavior: 'smooth' });

  // ✅ Mobile view: center the clicked step horizontally
  if (window.innerWidth <= 767) {
    const stepEl = stepperEl.querySelector(`.step[data-step="${step}"]`);
    if (stepEl) {
      const container = stepperEl;

      // Calculate center offset
      const containerRect = container.getBoundingClientRect();
      const stepRect = stepEl.getBoundingClientRect();

      const offset =
        stepRect.left - containerRect.left - containerRect.width / 2 + stepRect.width / 2;

      container.scrollBy({ left: offset, behavior: "smooth" });
    }
  }
}

function completeRegistration() {
  state.registered = true;
  setWithExpiry('voltyid:registered', 'true');
}


/* =========================================
   EMAIL VALIDATION
========================================= */
function validateEmail(email) {
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return pattern.test(email);
}

/* =========================================
   REGISTRATION SUBMIT (STABLE VERSION)
========================================= */

function handleRegistration() {

  console.log("Registration triggered");

  const getVal = (selector) =>
    document.querySelector(selector)?.value.trim() || "";

  const fields = {
    first_name: getVal('input[name="first_name"]'),
    last_name: getVal('input[name="last_name"]'),
    company_name: getVal('input[name="company_name"]'),
    email: getVal('input[name="email"]'),
    phone_number: getVal('input[name="phone_number"]'),
    serial_number: getVal('input[name="serial_number"]'),
    address: getVal('input[name="address"]'),
    city: getVal('input[name="city"]'),
    state: getVal('select[name="state"]'),
    zipcode: getVal('input[name="zipcode"]'),
    order_from:
      document.querySelector('select[name="order_from"]')?.value || "",
    order_number: getVal('input[name="order_number"]'),
    edition: getVal('select[name="edition"]'),
    users: getVal('select[name="number_of_user"]'),
  };

  const errorBox = document.querySelector(".error-msg");

  const amazonInput = document.querySelector(
    'input[name="amazon_order"]'
  );

  const voltyidInput = document.querySelector(
    'input[name="voltyid_order"]'
  );

  const otherInput = document.querySelector(
    'input[name="other_order"]'
  );

  if (errorBox) {
    errorBox.innerHTML = "";
    errorBox.style.display = "none";
  }

  const validateField = (condition, selector, message) => {

    const input = document.querySelector(selector);

    if (!input) return true;

    // Remove previous error message
    if (
      input.nextElementSibling &&
      input.nextElementSibling.classList.contains("field-error")
    ) {
      input.nextElementSibling.remove();
    }

    // Remove old error class
    input.classList.remove("input-error");

    // Add new error if invalid
    if (condition) {

      input.classList.add("input-error");

      const errorMsg = document.createElement("div");

      errorMsg.className = "field-error";
      errorMsg.textContent = message;

      input.insertAdjacentElement("afterend", errorMsg);

      return false;

    }

    return true;

  };

  let valid = true;

  valid &= validateField(
    !fields.first_name,
    'input[name="first_name"]',
    "First name required"
  );

  valid &= validateField(
    !fields.last_name,
    'input[name="last_name"]',
    "Last name required"
  );

  valid &= validateField(
    !fields.phone_number,
    'input[name="phone_number"]',
    "Phone number required"
  );

  valid &= validateField(
    !fields.email,
    'input[name="email"]',
    "Email required"
  );

  valid &= validateField(
    fields.email && !validateEmail(fields.email),
    'input[name="email"]',
    "Invalid email"
  );

  valid &= validateField(
    !fields.serial_number,
    'input[name="serial_number"]',
    "Serial number required"
  );

  valid &= validateField(
    !fields.address,
    'input[name="address"]',
    "Address required"
  );

  valid &= validateField(
    !fields.city,
    'input[name="city"]',
    "City required"
  );

  valid &= validateField(
    !fields.state,
    'select[name="state"]',
    "State required"
  );

  valid &= validateField(
    !fields.zipcode,
    'input[name="zipcode"]',
    "Zipcode required"
  );

  valid &= validateField(
    !fields.order_number,
    'input[name="order_number"]',
    "Order number required"
  );

  valid &= validateField(
    !fields.edition,
    'select[name="edition"]',
    "Edition required"
  );

  // Stop if validation fails
  // Form data remains preserved
  if (!valid) return;

  // Clear hidden fields before assigning
  if (amazonInput) amazonInput.value = "";
  if (voltyidInput) voltyidInput.value = "";
  if (otherInput) otherInput.value = "";

  if (fields.order_from === "amazon" && amazonInput) {

    amazonInput.value = fields.order_number;

  } else if (
    fields.order_from === "volty" &&
    voltyidInput
  ) {

    voltyidInput.value = fields.order_number;

  } else if (otherInput) {

    otherInput.value = fields.order_number;

  }

  const amazon_order = amazonInput?.value || "";
  const volty_order = voltyidInput?.value || "";
  const other_order = otherInput?.value || "";

  const overlay = document.getElementById(
    "ajax-loader-overlay"
  );

  if (overlay) {
    overlay.style.display = "flex";
  }

  fetch("https://license.voltyid.com/api/v1/registered", {
    method: "POST",
    body: JSON.stringify({
      ...fields,
      amazon_order,
      volty_order,
      other_order,
    }),
  })

    .then((res) => res.json())

    .then((response) => {

      if (overlay) {
        overlay.style.display = "none";
      }

      if (response.status === "200") {

        const modalEl = document.getElementById(
          "printer-registration-modal"
        );

        const modal = new bootstrap.Modal(modalEl);

        modal.show();

        modalEl.addEventListener(
          "shown.bs.modal",
          () => {
            stepperEl.classList.add(
              "stepper-disabled"
            );
          }
        );

        modalEl.addEventListener(
          "hidden.bs.modal",
          () => {
            stepperEl.classList.remove(
              "stepper-disabled"
            );
          }
        );

        const activationKey =
          response.activation_key;

        const productID = response.product_id;

        setWithExpiry(
          "voltyid:activation_key",
          activationKey
        );

        setWithExpiry(
          "voltyid:modelProductId",
          productID
        );

        document.getElementById(
          "acti-code"
        ).value = activationKey;

        document.querySelector(
          "#register-your-printer .license-info"
        ).innerHTML =
          `<div class="alert alert-success f--16px lh--loosev mf--14px">
            <strong>Congratulations!</strong>
            Your Printer Registered Successfully &
            Your Software Activation Key Is:
            "<strong>${activationKey}</strong>"
          </div>`;

        completeRegistration();

        setWithExpiry(
          "order_number",
          fields.order_number
        );

        goToStep(2);

        // Reset form ONLY after success
        document.querySelectorAll(
          '#register-your-printer input:not([type="hidden"]), #register-your-printer select'
        ).forEach((el) => {

          el.classList.remove("input-error");

          if (
            el.nextElementSibling &&
            el.nextElementSibling.classList.contains(
              "field-error"
            )
          ) {
            el.nextElementSibling.remove();
          }

          if (el.tagName === "SELECT") {
            el.selectedIndex = 0;
          } else {
            el.value = "";
          }

        });

        // Clear hidden order fields
        if (amazonInput) amazonInput.value = "";
        if (voltyidInput) voltyidInput.value = "";
        if (otherInput) otherInput.value = "";

      } else {

        // API failed
        // Form data preserved

        if (errorBox) {

          errorBox.innerHTML =
            `<div class="alert alert-danger f--16px lh--loosev mf--14px">
              ${response.message || "Something went wrong"}
            </div>`;

          errorBox.style.display = "block";

        }

      }

    })

    .catch((err) => {

      if (overlay) {
        overlay.style.display = "none";
      }

      // API/network error
      // Form data preserved

      if (errorBox) {

        errorBox.innerHTML =
          `<div class="alert alert-danger f--16px lh--loosev mf--14px">
            Something went wrong. Please try again.
          </div>`;

        errorBox.style.display = "block";

      }

      console.error(err);

    });

}


/* =========================================
   BIND EVENTS
========================================= */

document.addEventListener("DOMContentLoaded", function () {

  const form = document.querySelector("#registerForm");
  const btn = document.getElementById("submit-register-your-printer");

  if (!form || !btn) return;

  form.addEventListener("submit", function (e) {

    e.preventDefault();
    e.stopImmediatePropagation();

    handleRegistration();

  });

  btn.addEventListener("click", function (e) {

    e.preventDefault();
    e.stopImmediatePropagation();

    handleRegistration();

  });

});

/* =========================================
   INIT
========================================= */
function initRegistration() {

  buildStepper();

  if (modelData) {
    state.step = 2;
    setWithExpiry('voltyid:step', 2);
  }

  renderStepper();
  showStep(state.step);
}

document.addEventListener('DOMContentLoaded', function () {





  // --- Handle welcome screen "model" buttons ---
  $$('.model').forEach((btn) => {
    btn.addEventListener('click', () => {
      // Hide welcome
      welcomeView.classList.add("hidden");
      welcomeView.classList.remove("visible");

      // Show steps
      stepsView.classList.add("visible");
      stepsView.classList.remove("hidden");
      stepperWrap.classList.add("visible");

      // Start from step 1
      state.currentStep = 1;
      setWithExpiry("voltyid:step", "1");

      // ✅ Remove ?step=welcome from URL so refresh doesn't bring it back
      const url = new URL(window.location);
      url.searchParams.delete("step");
      window.history.replaceState({}, "", url);

      renderStepper();
      showStep(1);
    });
  });

  // --- Handle generic [data-next] buttons ---
  $$('[data-next]').forEach((btn) => {
    btn.addEventListener('click', () => {
      goToStep(Number(btn.dataset.next));
    });
  });

  // --- Init stepper ---
  buildStepper();
  setViewVisibility();
  renderStepper();
  showStep(state.currentStep);


  // ===============================
  // STEP 2 DYNAMIC CONTENT
  // ===============================
  if (modelData) {

    const ul = document.querySelector('#step-2 .description-box ul');
    if (!ul) return;

    // Store static elements before clearing
    const softwareItem = ul.querySelector('.static-software');
    const staticItems = ul.querySelectorAll('.static-item');

    // Clear list
    ul.innerHTML = '';

    // ===============================
    // 1️⃣ Printer (Dynamic)
    // ===============================
    ul.insertAdjacentHTML('beforeend', `
    <li class="g-box">
      <div class="box-images">
        <img src="${modelData.modelImage}" 
              alt="${modelData.model}" 
              class="img-fluid">
      </div>
      <p class="f--16px lh--loosev f--bold-500 f--black mf--14px mt-2 mb-0 truncate-3">
        ${modelData.model}
      </p>
    </li>
   `);

    // ===============================
    // 2️⃣ Software (Static)
    // ===============================
    if (softwareItem) {
      ul.appendChild(softwareItem);
    }

    // ===============================
    // 3️⃣ Bundle Products (Dynamic)
    // ===============================
    if (modelData.bundleProducts?.length) {
      modelData.bundleProducts.forEach(product => {
        ul.insertAdjacentHTML('beforeend', `
        <li class="g-box">
          <div class="box-images">
            <img src="${product.image}" 
                  alt="${product.title}" 
                  class="img-fluid">
          </div>
          <p class="f--16px lh--loosev f--bold-500 f--black mf--14px mt-2 mb-0 truncate-3">
            ${product.title}
          </p>
        </li>
      `);
      });
    }

    // ===============================
    // 4️⃣ Remaining Static Items
    // ===============================
    staticItems.forEach(item => {
      ul.appendChild(item);
    });

  }

  //Load the Code 
  if (getWithExpiry("voltyid:activation_key")) {
    document.getElementById("acti-code").value = getWithExpiry("voltyid:activation_key");
  }
});